import { IndexModel } from "../Support/IndexModel";
export class OrderIndex extends IndexModel {
    endpoint = 'order';
    getData() {
        return super.getData();
    }
}
